import { envConfig } from "../../utils/constants";
import { CurrencyState } from "../../utils/interfaces/currency";
import { client } from "../graphql";
import { GET_CURRENCY } from "./queries";

class CurrencyServices {
  async fetchCurrency(): Promise<CurrencyState> {
    const res = await client.query({
      query: GET_CURRENCY,
      context: { headers: { store: envConfig.store } },
    });
    return res.data.currency;
  }

  setCurrency = async (action: (res: any) => void, callbak: () => void) => {
    await this.fetchCurrency()
      .then((res: any) => {
        if (res) action(res);
        callbak();
      })
      .catch((e: Error) => {
        callbak();
      });
  };
}

export default new CurrencyServices();
